import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Same helper both apps keep in `lib/utils`. Duplicated rather than imported —
 * a package can't reach into an app, and it is two lines. */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
